import React, { useState } from 'react'
import Cookies from 'universal-cookie'
import { Alert } from 'reactstrap'
import { Button } from 'tabler-react'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
// Local import
import { withContext } from '../../context/withContext'
import { Input } from '../../components/FormGroups'
import { API } from '../../utils/config'
import { ControlFieldTypes } from '../../helpers/functions'
const cookies = new Cookies()

function Login(props) {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [alert, showAlert] = useState(false)
    const [loading, showLoading] = useState(false)

    const handleLogin = (e) => {
        e.preventDefault()
        showAlert(false)
        showLoading(true)
        API.post('/login/', { username: username, password: password })
            .then((response) => {
                cookies.set('toggle', false, { path: '/' })
                cookies.set('token', response.data.token, { path: '/' })
                let data = {
                    user: response.data.user,
                    field_types: ControlFieldTypes(response.data.company.plan_config, response.data.field_types),
                    token: response.data.token,
                    company: response.data.company,
                    isLogged: true,
                }
                props.updateContextVal(data)
                showLoading(false)
                this.props.history.push('/')
            })
            .catch((err) => {
                showAlert(true)
                showLoading(false)
            })
    }

    return (
        <div className="page">
            <div className="page-single">
                <div className="container">
                    <div className="row">
                        <div className="col col-login mx-auto">
                            <div className="text-center mb-6">
                                <img
                                    src={
                                        'https://d2p0bx8wfdkjkb.cloudfront.net/static/companies/2020/8/jDDbLMFGKK-formly-logo.png'
                                    }
                                    style={{ width: '100%', paddingTop: '1rem' }}
                                />
                            </div>
                            <form className="card" onSubmit={handleLogin}>
                                <div className="card-body p-6">
                                    <div className="card-title">Let's make today a great day</div>
                                    <Input
                                        required
                                        type="text"
                                        label="Email"
                                        id="username"
                                        placeholder="Email Address"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value.toLowerCase().replace(' ', ''))}
                                    />
                                    <Input
                                        required
                                        type="password"
                                        label="Password"
                                        id="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <div className="form-footer">
                                        <Button loading={loading} color="primary" className="btn-block" type="submit">
                                            Login
                                        </Button>
                                        <center className="mt-3">
                                            <Link to="/register">Register For Formly</Link> |{' '}
                                            {/* <Link to="/forgot-password">Forgot my Password</Link> */}
                                        </center>
                                    </div>
                                    {alert && (
                                        <Alert color="danger" className="mt-4">
                                            <center>Login information is incorrect!</center>
                                        </Alert>
                                    )}
                                </div>
                            </form>
                            <center>Formly (c) - All Rights Reserved.</center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(withContext(Login))
